import { Link } from "react-router-dom";
import { useLang } from "@/contexts/LanguageContext";
import { useT } from "@/lib/i18n";
import { HOME } from "@/constants/testIds";

const LOGO_ROUND =
    "https://customer-assets-jt897jd0.emergentagent.net/job_18a53554-3c4c-4394-97e9-2d39c51c5281/artifacts/4eg9cvl3_232787.jpg";

const Footer = ({ settings }) => {
    const { lang } = useLang();
    const t = useT(lang);

    return (
        <footer data-testid={HOME.footer} className="relative py-16 md:py-24" style={{ background: "var(--ink-1)", color: "#FFF0F5" }}>
            <div className="mx-auto max-w-[1600px] px-6 md:px-10">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-start">
                    <div className="md:col-span-5 flex items-center gap-4">
                        <span className="block w-16 h-16 rounded-full overflow-hidden shrink-0 anim-spin" style={{ animationDuration: "80s" }}>
                            <img src={LOGO_ROUND} alt="Piñatas con Karina" className="w-full h-full object-cover" />
                        </span>
                        <div>
                            <div className="font-serif text-2xl leading-none">
                                Piñatas <em className="font-hand text-3xl" style={{ color: "#FFC9D9" }}>con Karina</em>
                            </div>
                            <div className="font-body text-[10px] uppercase tracking-[0.28em] mt-2" style={{ color: "#FFC9D9" }}>
                                & Jump & Jump Rental Services LLC
                            </div>
                        </div>
                    </div>

                    <div className="md:col-span-3">
                        <div className="font-body text-[10px] uppercase tracking-[0.28em] mb-3" style={{ color: "#FFC9D9" }}>
                            {t("contact.location")}
                        </div>
                        <div className="font-serif text-xl">{lang === "es" ? settings?.address_es : settings?.address_en}</div>
                        <div className="font-body text-xs mt-2" style={{ color: "#F7B7CB" }}>{t("footer.hours")}</div>
                    </div>

                    <div className="md:col-span-4">
                        <div className="font-body text-[10px] uppercase tracking-[0.28em] mb-3" style={{ color: "#FFC9D9" }}>
                            {t("contact.eyebrow")}
                        </div>
                        <a
                            data-testid={HOME.footerPhone}
                            href={`tel:${(settings?.phone || "").replace(/\D/g, "")}`}
                            className="block font-serif text-3xl md:text-4xl mb-2 link-underline"
                        >
                            {settings?.phone}
                        </a>
                        <a
                            data-testid={HOME.footerWhatsapp}
                            href={`https://wa.me/1${(settings?.whatsapp || "8432510689").replace(/\D/g, "")}`}
                            target="_blank"
                            rel="noreferrer"
                            className="block font-serif text-xl md:text-2xl link-underline"
                        >
                            WhatsApp · {settings?.whatsapp_display}
                        </a>
                    </div>
                </div>

                <div className="mt-16 pt-6 flex items-center justify-between flex-wrap gap-3 font-body text-[11px] uppercase tracking-[0.28em]" style={{ borderTop: "1px solid rgba(255,201,217,0.25)", color: "#F7B7CB" }}>
                    <div>{t("footer.copy")}</div>
                    <Link to="/admin" data-testid={HOME.footerAdmin} className="link-underline">
                        {t("footer.admin")}
                    </Link>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
